/**
 *
 * @param {*} featureFlags
 * @param {*} getFeatureName
 * @param {*} element
 */
const isElementFeatureEnabled =
  (featureFlags, getFeatureName = () => null) =>
  (element) => {
    const featureName = getFeatureName(element);

    if (featureName) {
      return featureFlags.includes(featureName);
    }

    return true;
  };

export default isElementFeatureEnabled;
